// extracted by mini-css-extract-plugin
export var breadcrumbDivider = "CategoryHeader-module--breadcrumbDivider--rsyBX";
export var breadcrumbs = "CategoryHeader-module--breadcrumbs--FzBG6";
export var highlights = "CategoryHeader-module--highlights--M+Qq5";
export var highlightsWrapper = "CategoryHeader-module--highlightsWrapper--3Pato";
export var preamble = "CategoryHeader-module--preamble--b3h-R";
export var themeRose = "CategoryHeader-module--themeRose--cxtDa";
export var title = "CategoryHeader-module--title--MteDt";
export var totalProducts = "CategoryHeader-module--totalProducts--3ObUt";
export var wrapper = "CategoryHeader-module--wrapper---LNQ4";